import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "./Login.css";

const LoginPage = ({ setIsAuthenticated }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  const credentialRequestPending = useRef(false);

  useEffect(() => {
    const savedUsername = localStorage.getItem("rememberedUsername");
    if (savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "username") {
      setUsername(value);
    } else if (name === "password") {
      setPassword(value);
    }
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/login`,
        { username, password }
      );

      setMessage(response.data.message);
      if (response.data.token) {
        const decoded = jwtDecode(response.data.token);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userrole", decoded.userrole);

        if (decoded.userrole === "driver") {
          localStorage.setItem("driverName", decoded.name);
          localStorage.setItem("driverId", decoded.USER_ID);
          localStorage.setItem("badge", decoded.badge);
        }

        if (rememberMe) {
          localStorage.setItem("rememberedUsername", username);
        } else {
          localStorage.removeItem("rememberedUsername");
        }

        if (window.PasswordCredential && !rememberMe) {
          try {
            const cred = new window.PasswordCredential({
              id: username,
              password: password,
              name: username,
            });
            await navigator.credentials.store(cred);
          } catch (error) {
            console.error("Credential API storage error:", error);
          }
        }

        setTimeout(() => {
          setIsAuthenticated(true);
          navigate("/main", { replace: true });
        }, 50);
      }
    } catch (error) {
      setMessage(
        error.response ? error.response.data.message : "Error logging in."
      );
    }
  };

  // Auto-fill handler with enhanced cleanup
  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    const getCredentials = async () => {
      if (credentialRequestPending.current) return;
      credentialRequestPending.current = true;

      try {
        if (navigator.credentials?.get) {
          const credential = await navigator.credentials.get({
            password: true,
            signal: abortController.signal,
          });

          if (isMounted && credential) {
            setUsername(credential.id);
            setPassword(credential.password);
          }
        }
      } catch (error) {
        if (error.name === "InvalidStateError") {
          console.log("Credential request already pending, retrying...");
          setTimeout(() => getCredentials(), 500);
        } else if (error.name !== "AbortError") {
          console.error("Credential retrieval error:", error);
        }
      } finally {
        credentialRequestPending.current = false;
      }
    };

    const timeoutId = setTimeout(() => getCredentials(), 100);

    return () => {
      isMounted = false;
      abortController.abort();
      clearTimeout(timeoutId);
      credentialRequestPending.current = false;
    };
  }, []);

  const handleSignup = (e) => {
    e.preventDefault();
    navigate("/signup");
  };

  return (
    <div className="containerlogin">
      <form
        className="loginform"
        onSubmit={handleSubmit}
        method="POST"
        action="/login"
      >
        <div className="mb-3 logo-container">
          <img src="almadinalogo.jpeg" alt="Logo" className="logo" />
        </div>

        <div className="mb-3">
          <label className="labellogin">Login/User Id</label>
          <input
            type="text"
            className="input-fieldlogin"
            name="username"
            id="username"
            value={username}
            onChange={handleInputChange}
            required
            autoComplete="username webauthn"
            aria-describedby="usernameHelp"
          />
        </div>

        <div className="mb-3">
          <label className="labellogin">Password</label>
          <input
            type="password"
            className="input-fieldlogin"
            name="password"
            id="password"
            value={password}
            onChange={handleInputChange}
            required
            autoComplete="current-password webauthn"
          />
        </div>

        <div className="mb-3 form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id="rememberMe"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            autoComplete="off"
          />
          <label className="form-check-label" htmlFor="rememberMe">
            Remember Me
          </label>
        </div>

        <button type="submit" className="login-button">
          Login
        </button>

        <div className="links">
          <p>
            <a href="/signup" onClick={handleSignup}>
              Driver Sign Up
            </a>
            &nbsp;|&nbsp;
            <a href="/reset"> Reset Password </a>
          </p>
        </div>

        <div className="logo-container">
          <h5> Powered by </h5>
          <img src="bayanat.png" alt="Powered by" className="powered-by" />
        </div>
      </form>
      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default LoginPage;
